import { ADVERTISING_POLICY_LINK, POLICY_LINK, TERMS_LINK } from './links'
import type { AgreementsDocumentsCode } from '~/shared/types/agreements'

export const AGREEMENTS_CONSENT_CODES: Array<AgreementsDocumentsCode> = [
  'terms_accepted',
  'privacy_accepted',
  'policy_accepted',
  'marketing_accepted',
]

export const AGREEMENTS_FALLBACK_LINKS: Partial<Record<AgreementsDocumentsCode, string>> = {
  terms_accepted: TERMS_LINK,
  privacy_accepted: POLICY_LINK,
  policy_accepted: 'https://www.rshb.ru/pd-policy',
  marketing_accepted: ADVERTISING_POLICY_LINK,
}
